// Shared formatter for Cytoscape element ids based on arc/activity names.

export default function nameFormatter(name = '') {
    const sanitizedName = String(name).replace(/[^\w\s]/gi, '')
    return sanitizedName.replace(/\s/g, '-')
}
